import type { AxiosResponse } from 'axios'
import { isError } from '@/helpers/checkQuery'
import type { ResponseWrapper } from '@/api/types/base.types'

const SEND_ERROR_FALLBACK = 'Не удалось отправить сообщение'

const isTechnicalSendErrorText = (message: string): boolean => {
  const text = message.trim()
  if (!text) {
    return true
  }
  if (/cannot read propert/i.test(text)) {
    return true
  }
  if (/undefined/i.test(text) && /reading/i.test(text)) {
    return true
  }
  if (/^(type|reference|syntax)error:/i.test(text)) {
    return true
  }
  return false
}

const extractApiErrorText = (data: unknown): string | null => {
  if (!data || typeof data !== 'object') {
    return null
  }
  const record = data as { message?: unknown; error?: unknown }
  const raw = record.message ?? record.error
  if (typeof raw === 'string' && raw.trim()) {
    return raw.trim()
  }
  if (Array.isArray(raw)) {
    const joined = raw.map(String).join(', ').trim()
    return joined || null
  }
  return null
}

export const getCrmIntegrationApiErrorText = (
  res: AxiosResponse<ResponseWrapper<unknown>>,
  fallback: string,
): string => {
  if (!isError(res)) {
    return fallback
  }

  const data = res.data
  if (!data || typeof data !== 'object') {
    return fallback
  }
  if (data.status !== 'error') {
    return fallback
  }

  const { error } = data
  if (typeof error === 'string') {
    return error
  }
  if (Array.isArray(error)) {
    return error.join(', ')
  }

  return fallback
}

export const isCrmIntegrationHttpAccessDenied = (
  res: AxiosResponse<ResponseWrapper<unknown>>,
): boolean => res.status === 403

export const getCrmIntegrationSendErrorMessage = (sendError: unknown): string => {
  const axiosLike = sendError as {
    response?: { data?: unknown }
  }
  const apiText = extractApiErrorText(axiosLike?.response?.data)
  if (apiText && !isTechnicalSendErrorText(apiText)) {
    return apiText
  }

  if (sendError instanceof Error) {
    const message = sendError.message?.trim() ?? ''
    if (message && !isTechnicalSendErrorText(message)) {
      return message
    }
    return SEND_ERROR_FALLBACK
  }

  return SEND_ERROR_FALLBACK
}

export const CRM_INTEGRATION_SEND_FAILURE_MESSAGE = SEND_ERROR_FALLBACK
